import React from 'react';

import { SSRInlineCommentsInit } from './SSRInlineCommentsInit.tsx';

export const SSRInlineScriptsInit = ({}): React.JSX.Element => {
	return <SSRInlineCommentsInit />;
};
